export enum DownloadType {
  Excel = 'excel',
  Pdf = 'pdf',
}
